import { APP_CONFIG } from "../constants/global-variables.js";
export async function getGamesList() {
    const url = `${APP_CONFIG.URL.apiBasePath}gs/getgameslist`;
    const aa = localStorage.getItem("access_token");
    try {
        const res = await axios.get(url, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                "Content-Type": "application/json",
            },
        });
      return res.data;
    } catch (err) {
        //console.log('Error getting documents', err);
    }
}

export async function getHallId() {
    try {
        const res = await axios.get(`${APP_CONFIG.URL.apiBasePath}slots/hall`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                "Content-Type": "application/json",
            },
        });
        return res.data;
    } catch (err) {}
}

export async function getStargames(hallid) {
    if (!hallid) hallid = 13448;
    const aa = localStorage.getItem("access_token");
    try {
        const res = await axios.get(`https://apiserver.solutions/remote_games_list?type=html5&hallid=${hallid}&nocache=1&format=json`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                "Content-Type": "application/json",
            },
        });
        // if (res.data && res.data.gamelist.length > 0) {
        //     const index = res.data.gamelist.findIndex(game => game.family.name === 'Pragmatic');
        //     if (index !== -1) {
        //         const casinoGame = {
        //             "id": 7000,
        //             "name": "Live Casino",
        //             "group": "slots",
        //             "icon": "https://content.stargame.solutions/api/game/icon2/7000",
        //             "icon2": "https://content.stargame.solutions/api/game/icon4/7000",
        //             "isaristocrat": 0,
        //             "htmlposition": 0,
        //             "popularity": null,
        //             "width": 1024,
        //             "height": 768,
        //             "tournament": 0,
        //             "buybonus": 0,
        //             "jackpot": 0,
        //             "vendorflags": 0
        //         }
        //         res.data.gamelist[index].family.games.unshift(casinoGame);
        //     }
        // }
        return res.data;
    } catch (err) {
        //console.log('Error getting documents', err);
    }
}

export async function getPopularStargames(hallid) {
    if (!hallid) hallid = 12605;
    const aa = localStorage.getItem("access_token");
    try {
        const res = await axios.get(`https://apiserver.solutions/remote_games_list_pop?type=html5&hallid=${hallid}&nocache=1&format=json`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                "Content-Type": "application/json",
            },
        });
        return res.data;
    } catch (err) {}
}

export async function getNewStargames(hallid) {
    if (!hallid) hallid = 12605;
    const aa = localStorage.getItem("access_token");
    try {
        const res = await axios.get(`https://apiserver.solutions/remote_games_list_new?type=html5&hallid=${hallid}&nocache=1&format=json`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                "Content-Type": "application/json",
            },
        });
        return res.data;
    } catch (err) {}
}

export async function getJackpotsStarGame(sessionid,key1,key2) {
    const aa = localStorage.getItem("access_token");
    try {
        const res = await axios.get(`https://ac.umbrella-corp.company/jackpot/current?sid=${sessionid}&key1=${key1}&key2=${key2}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                "Content-Type": "application/json",
            },
        });
        return res.data;
    } catch (err) {
        //console.log('Error getting documents', err);
    }
}


export async function registerDeluxeCasino() {
    const url = `${APP_CONFIG.URL.apiBasePath}gs/register`;
    const aa = localStorage.getItem("access_token");
    try {
        const res = await axios.get(url, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                "Content-Type": "application/json",
            },
        });
      return res.data;
    } catch (err) {
        //console.log('Error getting documents', err);
    }
}


export async function loginDeluxeCasino() {
    const url = `${APP_CONFIG.URL.apiBasePath}gs/login`;
    try {
        const res = await axios.get(url, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                "Content-Type": "application/json",
            },
        });
      return res.data;
    } catch (err) {
        //console.log('Error getting documents', err);
    }
}